export const useAssetUrl = () => {
    // asset_url declared in resources/react/types/index.ts
    const url = window.asset_url ? window.asset_url : 'https://werkstatt.repareo.de/'

    return {
        url,
    }
}


